import api from './api'

export default {
  namespaced: true,
  state: {
    routeKey: 'categoryId',
    routes: {
      index: 'news.categories.index',
      create: 'news.categories.create',
      edit: 'news.categories.edit'
    },
    table: [
      { code: 'weight', type: 'integer', sort: true },
      { code: 'code', type: 'string', sort: true },
      { code: 'name', type: 'string', sort: true },
      { code: 'created_at', type: 'datetime', sort: true },
      { code: 'updated_at', type: 'datetime', sort: true }
    ],
    form: [
      { code: 'weight', type: 'text', validation: { required: true, integer: true } },
      { code: 'code', type: 'text', validation: { required: true } },
      { code: 'name', type: 'text', validation: { required: true } }
    ],
    item: {},
    items: [],
    meta: {},
    page: 1,
    sort: 'weight'
  },
  mutations: {
    SET_ITEMS (state, data) {
      state.items = data.data
      state.meta = data.meta
    },
    SET_ITEM (state, data) {
      state.item = {
        id: data.id || null,
        weight: data.weight || null,
        code: data.code || null,
        name: data.name || null
      }
    },
    SET_SORT (state, field) {
      state.sort = state.sort === field ? `-${field}` : field
    },
    SET_PAGE (state, page) {
      state.page = page
    }
  },
  actions: {
    async fetchItems ({ commit, state }) {
      const { data } = await api.index({
        'sort': state.sort,
        'page[number]': state.page
      })

      commit('SET_ITEMS', data)
    },
    clearItems ({ commit }) {
      commit('SET_ITEMS', {})
    },
    async fetchItem ({ commit }, { route }) {
      const { data: { data } } = await api.show(route.params.categoryId)

      commit('SET_ITEM', data)
    },
    clearItem ({ commit }) {
      commit('SET_ITEM', {})
    },
    async createItem ({ commit }, { form }) {
      const { data: { data } } = await api.store(form)

      commit('SET_ITEM', data)
    },
    async updateItem ({ commit }, { route, form }) {
      const { data: { data } } = await api.update(route.params.categoryId, form)

      commit('SET_ITEM', data)
    },
    async deleteItem ({ commit }, { id }) {
      await api.destroy(id)
    }
  }
}
